module.exports = __webpack_public_path__ + "img/pr_l2.b612eea4.png";